module.exports = {
  domain: 'O',
  title: 'פתוח לחוויות',
  shortDescription: 'פתיחות לחוויה מתארת מימד של סגנון קוגניטיבי שמבדיל בין אנשים דמיוניים ויצירתיים לבין אנשים רגילים.',
  description: `אנשים פתוחים הם סקרנים מבחינה אינטלקטואלית,
הערכה של אמנות, רגיש יופי. הם נוטים להיות,
לעומת אנשים סגורים, מודעים יותר לרגשותיהם. הם נוטים
לחשוב ולפעול באופן אינדיווידואליסטי ולא מתפשר
דרכים. אינטלקטואלים בדרך כלל ציון גבוה על פתיחות לחוויה;
כתוצאה מכך, גורם זה נקרא גם תרבות או
אינטלקט. <br /> <br /> יחד עם זאת, האינטלקט הוא כנראה הטוב ביותר נחשב היבט אחד של פתיחות
לחוות. ציונים על פתיחות לחוויה הם רק בצניעות
הקשורים שנים של חינוך וציונים על בדיקות אינטליגנטיות סטנדרטיות.
<br /> <br />
מאפיין נוסף של הסגנון הקוגניטיבי הפתוח הוא מתקן לחשיבה
בסמלים ובהפשטות רחוקים מהניסיון הקונקרטי. תלוי ב
יכולותיו האינטלקטואליות הספציפיות של היחיד, יכולה להיות הכרה סמלית זו
לובשים צורה של חשיבה מתמטית, לוגית או גיאומטרית, אמנותית ו
שימוש מטאפורי של שפה, הרכב מוסיקה או ביצועים, או אחד
אמנות חזותית או ביצוע רבים.
<br /> <br />
אנשים עם ציונים נמוכים על פתיחות לחוות נוטים להיות צרים, נפוצים
אינטרסים. הם מעדיפים את פשוט, פשוט, ברור על פני
מורכבת, מעורפלת, מתוחכמת. הם יכולים לראות את האמנות והמדעים עם
בחשדנות, ביחס למאמצים אלה כמשתמטים או ללא שימוש מעשי.
אנשים סגורים מעדיפים היכרות על חידוש; הם שמרנים
עמיד בפני שינוי.
<br /> <br />
פתיחות מוצגת לעתים קרובות יותר בריאה או בוגרת יותר על ידי פסיכולוגים, מי
הם לעתים קרובות עצמם פתוחים לחוות. עם זאת, סגנונות פתוחים וסגורים של
חשיבה שימושית בסביבות שונות. הסגנון האינטלקטואלי של
אדם פתוח יכול לשמש פרופסור היטב, אך מחקרים הראו כי סגור
החשיבה קשורה בביצוע עבודה מעולה בעבודה המשטרה, מכירות, ו
מספר מקצועות שירות.`,
  results: [
    {
      score: 'low',
      text: `הציון שלך על פתיחות לחוויה הוא נמוך, המציין שאתה אוהב לחשוב
פשוט ופשוט. אחרים מתארים אותך כמו על הקרקע, מעשי,
ו שמרני.`
    },
    {
      score: 'neutral',
      text: `הציון שלך על פתיחות לחוויה הוא ממוצע, המציין שאתה נהנה
אבל הם מוכנים לנסות דברים חדשים. החשיבה שלך היא לא
פשוט ולא מורכב. לאחרים אתה נראה אדם משכיל
אבל לא אינטלקטואל.`
    },
    {
      score: 'high',
      text: `הציון שלך על פתיחות לחוויה הוא גבוה, המציין שאתה נהנה חידוש,
מגוון, שינוי. אתה סקרן, דמיון ויצירתי.`
    }
  ],
  facets: [
    {
      facet: 1,
      title: 'דמיון',
      text: `לאנשים אמיתיים, העולם האמיתי הוא
לעתים קרובות מדי רגיל רגיל. ניקוד גבוה בקנה מידה זה להשתמש פנטזיה כמו
דרך ליצירת עולם עשיר, מעניין יותר. ניקוד נמוך הם על זה
בקנה מידה יותר מכוונת לעובדות מאשר פנטזיה.`
    },
    {
      facet: 2,
      title: 'עניין אומנותי',
      text: `ניקוד גבוה על היופי הזה יופי אהבה, הן ב
האמנות והטבע. הם נעשים בקלות וקלטים באמנות
ואירועים טבעיים. הם לא בהכרח מאומנים בצורה אומנותית ולא
מוכשר, אם כי רבים יהיו. המאפיינים המגדירים של סולם זה הם
עניין, הערכה של הטבע
יופי מלאכותי. לניקויים נמוכים חסרים רגישות ועניין אסתטיים
האומנויות.`
    },
    {
      facet: 3,
      title: 'רגשיות',
      text: `לאנשים בעלי רמת רגש גבוהה יש גישה טובה
אל המודעות והרגשות שלהם. ציון נמוך פחות מודעים
הרגשות שלהם נוטים לא להביע את רגשותיהם בגלוי.`
    },
    {
      facet: 4,
      title: 'הרפתקנות',
      text: `אנשים בעלי ניקוד גבוה על הרפתקנות הם להוטים
לנסות פעילויות חדשות, לנסוע לארצות זרות, ניסיון שונה
דברים. הם מוצאים היכרות משעמם שגרתית, ויקח חדש
המסלול הביתה רק בגלל זה שונה. נמוך scorers נוטים להרגיש
לא נוח עם שינוי ומעדיפים שגרות מוכרות.`
    },
    {
      facet: 5,
      title: 'אינטלקט',
      text: `אינטלקט ואינטרסים אמנותיים הם השניים ביותר
היבטים חשובים, מרכזיים של פתיחות להתנסות. ניקוד גבוה
אינטלקט אוהב לשחק עם רעיונות. הם פתוחים לחדשים ולא יוצאי דופן
רעיונות ורוצים לדון בסוגיות אינטלקטואליות. הם נהנים חידות, פאזלים,
ואת טייסס המוח. ציון נמוך על אינטלקט מעדיפים להתמודד עם אחד
אנשים או דברים במקום רעיונות. הם מתייחסים לתרגילים אינטלקטואליים כאל
בזבוז זמן. אינטלקט לא צריך להיות שווה עם אינטליגנציה.
האינטלקט הוא סגנון אינטלקטואלי, לא יכולת אינטלקטואלית, אם כי
ציון גבוה על ניקוד אינטלקט מעט גבוה יותר מאשר אינטלקט נמוך
אנשים על בדיקות מודיעיניות סטנדרטיות.`
    },
    {
      facet: 6,
      title: 'ליברליזם',
      text: `הליברליזם הפסיכולוגי מתייחס לנכונות
אתגר סמכות, מוסכמה וערכים מסורתיים. הכי הרבה שלה
קיצונית, הליברליזם הפסיכולוגי יכול אפילו לייצג באופן גלוי
עוינות לכללים, אהדה לשוברים חוק, ואהבת עמימות,
כאוס והפרעה. השמרנים הפסיכולוגיים מעדיפים את הביטחון
יציבות הנובעת מהתאמה למסורת. ליברליזם פסיכולוגי
השמרנות אינה זהה לזיקה הפוליטית, אבל בהחלט
אנשים משופעים כלפי מפלגות מסוימות.`
    }
  ]
}
